import EA from '../helpers/init';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, CustomEase);

export default EA.Methods.expandingCardScrollAnim = ($this) => {
    let tl;
    const pinnedElement = $this;
    const videoWrapper = $this.querySelector('.video-wrapper');
    const section = $this.closest('section');
    const secondaryElements = $this.parentNode.querySelectorAll('.secondary-anim');
    const spacer = $this.parentNode.parentNode.querySelector('.expanding-cards-spacer');
    const dummyElement = $this.parentNode.querySelector('.dummy');

    if (!videoWrapper || !spacer || !dummyElement) {
        return;
    }

    let initialized = false;

    const init = () => {
        if (initialized) return;
        initialized = true;

        const mm = gsap.matchMedia();

        const getWantedVideoRect = () => {
            const wantedVideoWidth = pinnedElement.offsetWidth - 1;
            const wantedVideoHeight = wantedVideoWidth / 16 * 9;

            return {
                width: wantedVideoWidth,
                height: wantedVideoHeight
            };
        };

        let pinDistance = 0;
        const getPinDistance = () => {
            const spacerTop = spacer.offsetTop;
            const pinnedTop = pinnedElement.offsetTop;

            pinDistance = (spacerTop - pinnedTop) * 1.5;
            return pinDistance;
        };

        getPinDistance();

        const setSpacerHeight = () => {
            spacer.style.height = `${pinDistance}px`;
        };

        const getPaddingBottom = () => parseFloat(getComputedStyle(section).paddingBottom) || 0;

        ScrollTrigger.saveStyles(videoWrapper);

        mm.add('(min-width: 1201px)', () => {
            setSpacerHeight();

            tl = gsap.timeline({
                defaults: {
                    ease: CustomEase.create('custom', 'M0,0,C0,0,0.068,-0.003,0.068,-0.003,0.578,0.234,0.588,0.964,0.914,0.999,0.914,0.999,1,1,1,1'),
                },
                scrollTrigger: {
                    trigger: pinnedElement,
                    pin: true,
                    pinSpacing: false,
                    start: `bottom+=${getPaddingBottom()} bottom`,
                    end: () => `+=${pinDistance}px`,
                    scrub: 2,
                    markers: false,
                    invalidateOnRefresh: true,
                    onRefresh: (self) => {
                        setSpacerHeight();
                    },
                },
                duration: 1,
            });

            tl.fromTo(secondaryElements, {
                y: 0,
            }, {
                y: '44px',
                duration: 0.4
            }, 0);

            tl.fromTo(videoWrapper, {
                width: () => dummyElement.offsetWidth,
                height: () => dummyElement.offsetHeight,
            },
            {
                width: () => getWantedVideoRect().width,
                height: () => getWantedVideoRect().height,
                duration: 0.7,
            }, 0.1);

            return () => {
                spacer.style.height = '';
                secondaryElements.forEach((item) => {
                    item.style.transform = '';
                });
            };
        });
    };


    const intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) return;

        intersectionObserver.disconnect();
        init();
        ScrollTrigger.refresh();
    },
    {
        root: null,
        threshold: 0,
        rootMargin: '100px',
    });

    const inRangeSoon = pinnedElement.getBoundingClientRect().top < window.innerHeight + 100;
    if (inRangeSoon) {
        init();
        ScrollTrigger.refresh(true);
    } else {
        intersectionObserver.observe(pinnedElement);
    }

    intersectionObserver.observe(pinnedElement);
};